import styled from 'particles/themes/styled'
import { theme } from 'theme'
export const EditTaskContainer = styled.div`
    display: flex;
    max-height: 100%;
    overflow: hidden;
    .sidebar {
        min-width: 244px;
        height: 100%;
        position: relative;
        #tasks-popup {
            position: absolute;
            left: 70px;
            top: 48px;
        }
        @media screen and (max-width: 768px) {
            display: none;
        }
    }
    .task-content {
        display: flex;
        align-items: flex-start;
        justify-content: center;
        width: 100%;
        height: 100%;
        overflow: hidden;
        padding-left: ${theme.newSpacing.l};
        @media screen and (max-width: 768px) {
            padding: 0 ${theme.newSpacing.xxs};
        }
        box-sizing: border-box;
        .editor-form {
            width: 100%;
            height: 100%;
            max-height: 100%;
            overflow-y: auto;
            display: flex;
            form {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                width: 100%;
                height: 100%;
                position: relative;
                background-color: ${theme.newColors.neutral50};
                .form-field {
                    display: flex;
                    gap: ${theme.newSpacing.l};
                    box-sizing: border-box;
                    &.no-background {
                        background-color: unset;
                    }
                }

                .button-group {
                    display: none;
                    max-width: 100%;
                    position: sticky;
                    bottom: 0;
                    height: fit-content;
                    background-color: ${theme.newColors.neutral50};
                    box-shadow: 2px 0px 8px rgba(0, 0, 0, 0.06);
                    padding: 14px ${theme.newSpacing.l};
                    display: flex;
                    justify-content: flex-end;
                    box-sizing: border-box;
                    gap: ${theme.newSpacing.l};
                    z-index: 200;
                    @media screen and (max-width: 768px) {
                        width: calc(100% - 32px);
                        left: 50%;
                        bottom: 0;
                        position: fixed;
                        transform: translateX(-50%);
                    }

                    &--left {
                        height: 100%;
                        margin-right: auto;
                    }
                }
            }
        }
        .open-small-sidebar {
            display: none;
        }
        .empty-state {
            align-self: center;
        }
        @media screen and (max-width: 768px) {
            flex-direction: column;
            height: fit-content;
            justify-content: flex-start;
            align-items: center;
            height: 100%;
            .open-small-sidebar {
                width: 100%;
                align-self: flex-start;
                display: flex;
                flex-direction: column;
                gap: ${theme.newSpacing.xxs};
                padding: 0 ${theme.newSpacing.m};
                box-sizing: border-box;
                .current-page {
                    font-size: ${theme.newFontSizes.s};
                    font-weight: ${theme.fontWeight.medium};
                }
                .current-page-open-button {
                    display: flex;
                    width: 100%;
                    justify-content: space-between;
                    border: 1px solid ${theme.newColors.neutral200};
                    border-radius: 4px;
                    align-items: center;
                    box-sizing: border-box;
                    height: 38px;
                    padding: 9px ${theme.newSpacing.s};
                    margin-bottom: ${theme.newSpacing.m};
                }
            }
            .empty-state {
                margin: 0 auto;
            }
        }
    }
    .small-device-sidebar {
        display: none;
        position: fixed;
        width: 100vw;
        top: 0;
        left: 0;
        height: 100vh;
        background-color: rgba(1, 1, 1, 0.4);
    }
`

export const SmallScreenSideBar = styled.div`
    position: relative;
    display: none;
    z-index: 110;
    &.show-small-sidebar {
        display: block;
        @media screen and (min-width: 768px) {
            display: none;
        }
    }

    #tasks-popup {
        position: absolute;
        left: 70px;
        top: 48px;
    }
`
